import errorImg from "assets/images/errors/500.png";
import { _ } from "i18n";
import { Link } from "react-router";
import "./errorPage.css";

export default function ServerErrorPage() {
	return (
		<div id="errorPage" className="errorPage-container">
			<div className="content">
				<img src={errorImg} className="errorImg" alt="" />
				<div className="error-text">{_("message.500page")}</div>
				<div className="error-text">{_("message.500page.info")}</div>
				<button type="button" className="backToHomeButton" onClick={() => window.location.reload()}>
					{_("label.refresh")}
				</button>
				<Link className="backToHomeButton" to="/">
					{_("label.button.backToHome")}
				</Link>
				<div className="ripple">
					<div className="circle" />
				</div>
			</div>
		</div>
	);
}
